import styled from 'styled-components'
import { Box } from 'src/components'

export const Google = styled(Box)`
    width: 100%;
    height: 400px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
